module.exports = __webpack_public_path__ + "static/media/csm-logo-dark.90bd8f48.svg";